export default "__VITE_ASSET__PlMiwfso__"